import { render, staticRenderFns } from "./PreviewEdit.vue?vue&type=template&id=ebb60afc&scoped=true&"
import script from "./PreviewEdit.vue?vue&type=script&lang=js&"
export * from "./PreviewEdit.vue?vue&type=script&lang=js&"
import style0 from "./PreviewEdit.vue?vue&type=style&index=0&id=ebb60afc&lang=scss&"
import style1 from "./PreviewEdit.vue?vue&type=style&index=1&id=ebb60afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb60afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebb60afc')) {
      api.createRecord('ebb60afc', component.options)
    } else {
      api.reload('ebb60afc', component.options)
    }
    module.hot.accept("./PreviewEdit.vue?vue&type=template&id=ebb60afc&scoped=true&", function () {
      api.rerender('ebb60afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/salesorder/PreviewEdit.vue"
export default component.exports